/**
 * Manual-play video hero: click the video (not the CTA) to play or pause.
 * Shows the overlay play icon again when paused.
 */
(() => {
  if (window.__videoHeroManualPlayBound) {
    return;
  }

  window.__videoHeroManualPlayBound = true;

  /**
   * Toggle the first video-element inside a manual-play hero.
   * @param {HTMLElement} videoElement
   */
  const toggleVideo = (videoElement) => {
    const nativeVideo = videoElement.querySelector('video');

    if (nativeVideo) {
      if (nativeVideo.paused) {
        videoElement.play();
        return;
      }

      videoElement.pause();
      nativeVideo.pause();
      return;
    }

    if (videoElement.playing) {
      videoElement.pause();
      return;
    }

    videoElement.play();
  };

  document.addEventListener('click', (event) => {
    const hero = event.target.closest('.video-hero--manual-play');

    if (!hero) {
      return;
    }

    if (event.target.closest('a, input, textarea, select, label')) {
      return;
    }

    const video = hero.querySelector('video-element');

    if (!video) {
      return;
    }

    toggleVideo(video);
  });
})();
